import React from 'react';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { Colours } from '../../tokens';
import SVG from '../SVG';
const useStyles = createUseStyles({
    root: {
        color: Colours.primary,
    },
});
function ZoneIcon({ className }) {
    const styles = useStyles();
    return (React.createElement(SVG, { width: "16", height: "16", viewBox: "0 0 16 16", className: classNames(styles.root, className) },
        React.createElement("g", { transform: "translate(-114 -257)" },
            React.createElement("g", { transform: "translate(6 5)" },
                React.createElement("path", { d: "M9.129,14.274H5.145C1.54,14.274,0,12.734,0,9.129V5.145C0,1.54,1.54,0,5.145,0H9.129c3.6,0,5.145,1.54,5.145,5.145V9.129C14.274,12.734,12.734,14.274,9.129,14.274ZM5.145,1C2.085,1,1,2.085,1,5.145V9.129c0,3.061,1.089,4.149,4.149,4.149H9.129c3.061,0,4.149-1.089,4.149-4.149V5.145C13.278,2.085,12.189,1,9.129,1Z", transform: "translate(108.833 252.833)", fill: "currentColor" }),
                React.createElement("path", { d: "M.5,14.274a.5.5,0,0,1-.5-.5V.5A.5.5,0,0,1,.5,0,.5.5,0,0,1,1,.5V13.776A.5.5,0,0,1,.5,14.274Z", transform: "translate(115.5 252.833)", fill: "currentColor" }),
                React.createElement("path", { d: "M7.137,1H.5A.5.5,0,0,1,0,.5.5.5,0,0,1,.5,0H7.137a.5.5,0,0,1,.5.5A.5.5,0,0,1,7.137,1Z", transform: "translate(108.833 257.833)", fill: "currentColor" }),
                React.createElement("path", { d: "M7.137,1H.5A.5.5,0,0,1,0,.5.5.5,0,0,1,.5,0H7.137a.5.5,0,0,1,.5.5A.5.5,0,0,1,7.137,1Z", transform: "translate(115.5 261.167)", fill: "currentColor" }),
                React.createElement("path", { d: "M0,0H16V16H0Z", transform: "translate(108 252) ", fill: "none", opacity: "0" })))));
}
export default ZoneIcon;
//# sourceMappingURL=ZoneIcon.js.map